<template>
  <div>
    <fixed-header :title="id == '' ? 'Add User' : 'Edit User'"  hideNewOfferBtn />
    <div class="card">
      <div class="card-body">
        <b-form @submit="onSubmit" @reset="onReset">
          <b-row class="d-none">
            <b-col cols="2" class="text-center">
              <h5>Profile</h5>
              <br>
              <image-uploader
                :preview="true"
                :className="['fileinput', { 'fileinput--loaded': hasImage }]"
                capture="environment"
                :debug="1"
                doNotResize="gif"
                :autoRotate="true"
                outputFormat="verbose"
                @input="setImage"
              >
                <label for="fileInput" slot="upload-label">
                  <figure>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="32"
                      height="32"
                      viewBox="0 0 32 32"
                    >
                      <path
                        class="path1"
                        d="M9.5 19c0 3.59 2.91 6.5 6.5 6.5s6.5-2.91 6.5-6.5-2.91-6.5-6.5-6.5-6.5 2.91-6.5 6.5zM30 8h-7c-0.5-2-1-4-3-4h-8c-2 0-2.5 2-3 4h-7c-1.1 0-2 0.9-2 2v18c0 1.1 0.9 2 2 2h28c1.1 0 2-0.9 2-2v-18c0-1.1-0.9-2-2-2zM16 27.875c-4.902 0-8.875-3.973-8.875-8.875s3.973-8.875 8.875-8.875c4.902 0 8.875 3.973 8.875 8.875s-3.973 8.875-8.875 8.875zM30 14h-4v-2h4v2z"
                      ></path>
                    </svg>
                  </figure>
                  <span class="upload-caption">
              {{
              hasImage ? "Replace" : "Click to upload"
              }}
            </span>
                </label>
              </image-uploader>
              <!-- <img alt="Vue logo" src="../assets/icons8-administrator-male-104.png">
              <br>
              <a style="font-size: small;" href>Change Photo</a>-->
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="3">
              <b-form-group id="input-group-0" label="Title:" label-for="input-0">
                <b-form-input
                  id="input-2"
                  v-model="form.title"
                  placeholder="Enter Title"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col cols="3">
              <b-form-group id="input-group-2" label="First Name:" label-for="input-2">
                <b-form-input
                  id="input-2"
                  v-model="form.firstName"
                  placeholder="Enter First Name"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col cols="3">
              <b-form-group id="input-group-3" label="Last Name:" label-for="input-3">
                <b-form-input id="input-3" v-model="form.lastName" placeholder="Enter Last Name"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col cols="3">
              <b-form-group id="input-group-1" label="Email address:" label-for="input-1">
                <b-form-input
                  id="input-1"
                  v-model="form.email"
                  type="email"
                  required
                  :disabled="id != ''"
                  placeholder="Enter email"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row v-if="!this.$route.params.id">
            <b-col>
              <b-form-group id="input-group-10" label="Password:" label-for="input-10">
                <b-form-input
                  id="input-10"
                  type="password"
                  v-model="form.password"
                  placeholder="Enter Password"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group id="input-group-11" label="Confirm Password:" label-for="input-11">
                <b-form-input
                  id="input-11"
                  type="password"
                  v-model="form.confirmPassword"
                  placeholder="Confirm Password"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="mt-2">
            <b-col>
              <b-form-group id="input-group-4" label="Phone:" label-for="input-4">
                <b-form-input id="input-4" v-model="form.phoneNumber" placeholder="Phone"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group id="input-group-5" label="Mobile:" label-for="input-5">
                <b-form-input id="input-5" v-model="form.mobile" placeholder="Mobile"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="mt-2">
            <b-col cols="7">
              <b-form-group id="input-group-6" label="Address:" label-for="input-6">
                <b-form-input id="input-6" v-model="form.address" placeholder="Address"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col cols="5">
              <b-form-group id="input-group-7" label="Suite/Apt:" label-for="input-7">
                <b-form-input id="input-7" v-model="form.suiteApt" placeholder="Suite/Apt"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="mt-2">
            <b-col cols="5">
              <b-form-group id="input-group-8" label="City:" label-for="input-city">
                <b-form-input id="input-city" v-model="form.city" placeholder="City"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col cols="4">
              <label for="input-state">State</label>
              <b-form-select id="input-state" v-model="form.state" :options="stateOptions"></b-form-select>
              <!-- <select id="input-state">
                <option value="FL">FL</option>
              </select>-->
            </b-col>
            <b-col cols="3">
              <b-form-group id="input-group-9" label="Zip:" label-for="input-zip">
                <b-form-input id="input-zip" v-model="form.zip" placeholder="Zip"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="mt-2">
            <b-col>
              <label>Roles:</label>
              <multiselect
                :multiple="true"
                track-by="name"
                :close-on-select="false"
                :clear-on-select="false"
                label="name"
                v-model="form.roles"
                :options="roles"
              ></multiselect>
            </b-col>
          </b-row>
          <b-row class="mt-2">
            <b-col>
              <b-form-group id="input-group-10" label="Sale Bogie:" label-for="input-commission-rate">
                <b-input-group prepend="$" size="sm">
                <b-form-input id="input-sale-quota" v-model="form.saleQuota" placeholder="Sale Bogie"></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
            <!-- <b-col cols="3">
              <b-form-group id="input-group-11" label="Sale Commission Rate:" label-for="input-sale-commission-rate">
                <b-input-group prepend="%" size="sm">
                  <b-form-input id="input-sale-commission-rate" v-model="form.saleCommissionRate" placeholder="Sale Commission Rate"></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col> -->
            <b-col>
              <b-form-group id="input-group-12" label="Purchase Bogie:" label-for="input-purchase-quota">
                <b-input-group prepend="$" size="sm">
                  <b-form-input id="input-purchase-quota" v-model="form.purchaseQuota" placeholder="Purchase Bogie"></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
            <!-- <b-col cols="3">
              <b-form-group id="input-group-13" label="Purchase Commission Rate:" label-for="input-purchase-commission-rate">
                <b-input-group prepend="%" size="sm">
                  <b-form-input id="input-purchase-commission-rate" v-model="form.purchaseCommissionRate" placeholder="Purchase Commission Rate"></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col> -->
          </b-row>
          <b-row>
            <b-col>
              <div>
                <b-button type="submit" variant="primary" style="margin: 5px;" :disabled="onSaving">Save</b-button>
                <b-button style="margin: 5px;" @click="cancel">Cancel</b-button>
                <b-button style="margin: 10px;" v-if="id && form.email" @click="onResetPassword" :disabled="onResettingPw">
                  <i v-if="onResettingPw" class="fa fa-spinner fa-pulse fa-fw mr-1"></i>
                    Reset Password
                </b-button>
              </div>
            </b-col>
          </b-row>
        </b-form>
      </div>
    </div>
  </div>
</template>

<script>
import ajax from '@/resources/myApi.js';
import FixedHeader from '@/shared/components/FixedHeader/indexNew';
import Multiselect from 'vue-multiselect';
import { mapActions } from 'vuex';

export default {
  name: 'edit-user',
  components: { Multiselect, FixedHeader },
  data() {
    return {
      form: {
        email: '',
        title: '',
        firstName: '',
        lastName: '',
        password: '',
        confirmPassword: '',
        active: true,
        mobile: '',
        address: '',
        suiteApt: '',
        city: '',
        state: 'FL',
        zip: '',
        roles: [],
      },
      stateOptions: [{ value: 'FL', text: 'FL' }],
      errors: [],
      /*roles: [{ name: 'Administrator' }, { name: 'Client' }],*/
      roles: [],
      show: true,
      hasImage: false,
      id: '',
      loader: null,
      onSaving: false,
      onResettingPw: false
    };
  },
  methods: {
    ...mapActions('users', ['getById']),
    ...mapActions('settings', ['getRoles']),
    ...mapActions('salesReps', ['getSalesReps']),
    ...mapActions('account', ['forgotPassword']),
    cancel() {
      this.$router.push({ name: 'UserList' });
    },
    setImage: function(file) {
      this.hasImage = true;
      this.image = file;
    },
    onSubmit(evt) {
      evt.preventDefault();
      var data = Object.assign({}, this.form);
      data.roles = [];
      this.form.roles.map(function(key) {
        data.roles.push(key.name);
      });
      //this.loader = this.$loading.show();
      this.onSaving = true;
      if (this.$route.params.id) {
        ajax.put('api/user/' + this.id, {
          name: 'updateUser',
          body: data,
        }).then(response => {
          console.log(response);
          this.onSaving = false;
          this.getSalesReps(true);
          //this.loader.hide();
          this.$snotify.success('User saved', 'User');
          this.$router.push({ name: 'UserList' });
        });
      } else {
        if (data.password != data.confirmPassword) {
          alert("Password does not match.");
          this.onSaving = false;
          return;
        }
        ajax.post('api/user/create',
          {
            name: 'newUser',
            body: data,
          }).then(response => {
          console.log(response);
          this.onSaving = false;
          this.getSalesReps(true);
          //this.loader.hide();
          this.$snotify.success('User created', 'User');
          this.$router.push({ name: 'UserList' });
        }).catch(() => {
          //this.loader.hide();
          this.onSaving = false;
        })
      }
      
    },
    handleRoles() {
      //console.log(rol);
    },
    onReset(evt) {
      evt.preventDefault();
      // Reset our form values
      this.form.email = '';
      this.form.title = '';
      this.form.firstName = '';
      this.form.lastName = '';
      this.form.mobile = '';
      this.form.address = '';
      this.form.active = true;
      this.form.checked = [];
      // Trick to reset/clear native browser form validation state
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    },
    async onResetPassword() {
      this.onResettingPw = true;
      const res = await this.forgotPassword({email: this.form.email }).catch(() => {this.onResettingPw = false});
      if (res.status == 200) {
        this.$snotify.success('Successfully reset password.');
      } else {
        this.$snotify.error('There is an issue in resetting password.');
      }
      this.onResettingPw = false;
    }
  },
  async created() {
    this.id = this.$route.params.id;

    if (this.id) {
      this.setContainerLoader(true);
      this.getById(this.id).then(response => {
        this.setContainerLoader(false);
        this.form = Object.assign({},response);
        this.form.roles = [];
        Object.values(response.roles).forEach((value)=>{
          this.form.roles.push({ name: value });
        });
      }).catch(() => {
        this.setContainerLoader(false);
        //return back to listing page because error in fetch record
        this.$router.push({name: 'UserList'});
      });
    }

    this.roles = await this.getRoles();

  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
<style>
#fileInput {
  display: none;
}
.img-preview {
  width: 200px;
}
</style>
